
    import Vue from 'vue';
    import {Ripple} from 'vuetify/lib/directives/';

    function requestDefaultValues () {
        return {
            oas: null,
            preLearnings: null,
            skills: null,
            attitudes: null,
        }
    }

    export default Vue.extend({
        name: 'RomaExcelModalForm',
        props: {
            value: Boolean,
            activity: Object,
            maxWidth: {
                type: String,
                default: '90%',
            },
            overlayOpacity: {
                type: String,
                default: '0.8',
            },
            persistent: {
                type: Boolean,
                default: true,
            },
        },
        data() {
            return {
                valid: false,
                loading: false,
                showing: this.value,
                request: requestDefaultValues(),
            };
        },
        methods: {
            show(value: Boolean) {
                this.$emit('input', value);
                this.request = requestDefaultValues();
            },
            async save () {

                let _this = this;

                async function upload (file: File, tipo: number = 0) {
                    if (file) {
                        try {
                            _this.loading = true;
                            const response = await _this.$store.dispatch('uploadExcels', {file: file, tipo: tipo}, {headers: {'Content-Type': 'multipart/form-data'}});
                            // console.log("response", response);
                            let msj = {
                                show: true,
                                text: '',
                                color: 'success',
                            };
                            if (response.data && response.data.status && response.data.status.code === 1) {
                                msj.text = response.data.content;
                                msj.color = 'success';
                            } else if (Array.isArray(response.data.content)) {
                                msj.text = response.data.content.map(error => error.message);
                                msj.color = 'red';
                            } else if (response.data && response.data.status && response.data.status.code === 3) {
                                msj.text = response.data.content.message;
                                msj.color = 'red';
                            } else {
                                msj.text = 'No se pudo procesar su solicitud';
                                msj.color = 'red';
                            }
                            _this.loading = false;
                            if (!Array.isArray(_this.$store.state.snackbar)) _this.$store.state.snackbar = [];
                            _this.$store.state.snackbar.push(msj);
                            return response;
                        } catch (errors) {
                            console.log(errors);
                            _this.loading = false;
                            _this.$store.state.snackbar = msj; // mostrar mensaje
                            return ('errores', errors);
                        }
                    }
                }

                await upload(this.request.oas, 0);
                await upload(this.request.preLearnings, 1);
                await upload(this.request.attitudes, 2);
                await upload(this.request.skills, 3);

                if (_this.$store.state.snackbar.filter(snack => snack.show).every(snack => snack.color === 'success')) this.show(false);
            }
        },
        directives: {
            Ripple
        }
    });
